// extracted by mini-css-extract-plugin
export var legendIndicator = "_f4-1";
export var legendRight = "_f4-0";